import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import api from '../../../../api';  // Ensure this path matches your API utility file

export const fetchReimbursement = createAsyncThunk("reimbursement/fetchReimbursement", async (searchText) => {
  const response = await api.post("/reimbursement",{ search: searchText });
  console.log(response)
  return response.data.data;
});

export const addReimbursement = createAsyncThunk(
  "reimbursement/addReimbursement",
  async (reimbursementData, { dispatch, rejectWithValue }) => {
    try {
      const response = await api.post("/add-user", reimbursementData);
      dispatch(fetchReimbursement());
      return response.data.message;  // Success message from backend
    } catch (error) {
      return rejectWithValue(error.response?.data.message || "Failed to save user");
    }
  }
);

export const deleteReimbursement = createAsyncThunk(
  "reimbursement/deleteReimbursement",
  async (reimbursementId, { dispatch, rejectWithValue }) => {
    try {
      const response = await api.post(`/delete-employee/${reimbursementId}`);
      dispatch(fetchReimbursement());
      return response.data.message;  // Success message from backend
    } catch (error) {
      return rejectWithValue(error.response?.data.message || "Failed to delete user");
    }
  }
);

// Define the initial state and slice
const reimbursementSlice = createSlice({
  name: "reimbursementData",
  initialState: {
    data: [],
    loading: false,
    isModalOpen: false,
    selectedUserId: null,
    addLoading: false,
    deleteLoading: false,
    error: null,
    successMessage: null,
  },
  reducers: {
    openReimbursementModal: (state, action) => {
      state.isModalOpen = true;
      state.selectedUserId = action.payload || null;
    },
    closeReimbursementModal: (state) => {
      state.isModalOpen = false;
      state.selectedUserId = null;
      state.error = null;
      state.successMessage = null;
    },
    clearError: (state) => {
      state.error = null;
      state.successMessage = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchReimbursement.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchReimbursement.fulfilled, (state, action) => {
        state.data = action.payload;
        state.loading = false;
      })
      .addCase(fetchReimbursement.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
      })
      .addCase(addReimbursement.pending, (state) => {
        state.addLoading = true;
      })
      .addCase(addReimbursement.fulfilled, (state, action) => {
        state.addLoading = false;
        state.successMessage = action.payload;
      })
      .addCase(addReimbursement.rejected, (state, action) => {
        state.addLoading = false;
        state.error = action.payload;
      })
      .addCase(deleteReimbursement.pending, (state) => {
        state.deleteLoading = true;
      })
      .addCase(deleteReimbursement.fulfilled, (state, action) => {
        state.deleteLoading = false;
        state.successMessage = action.payload;
      })
      .addCase(deleteReimbursement.rejected, (state, action) => {
        state.deleteLoading = false;
        state.error = action.payload;
      });
  },
});

export const { openReimbursementModal, closeReimbursementModal, clearError } = reimbursementSlice.actions;
export default reimbursementSlice.reducer;
export { reimbursementSlice };